export const REPORT_TYPES = ['coverage', 'periodic', 'campaign', 'excel'] as const;
export const REPORT_PERIODS = ['monthly', 'quarterly'] as const;
export const REPORT_LANGUAGES = ['en', 'fr', 'it', 'es'] as const;
export const REPORT_CURRENCIES = ['EUR', 'USD', 'JPY', 'CNY', 'GBP', 'AUD'] as const;
export const MAX_FEED_DOCUMENTS = 20000 as const;
